const SNAPSHOT_PREFIX = "hologram_page_snapshot_";

let bfcacheGuard = false;

function clearSessionStorageSnapshots() {
  const keys = [];

  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key?.startsWith(SNAPSHOT_PREFIX)) keys.push(key);
  }

  for (const key of keys) {
    sessionStorage.removeItem(key);
  }
}

async function clearOpfsSnapshots() {
  if (!navigator.storage?.getDirectory) return;

  try {
    const root = await navigator.storage.getDirectory();

    for await (const name of root.keys()) {
      if (typeof name === "string" && name.startsWith(SNAPSHOT_PREFIX)) {
        await root.removeEntry(name);
      }
    }
  } catch {
    // OPFS optional; sessionStorage clear is the critical path
  }
}

/** Drop SPA history snapshots so back cannot restore sealed survey pages. */
export async function clearHologramPageSnapshots() {
  clearSessionStorageSnapshots();
  await clearOpfsSnapshots();
}

/** Full document navigation after logout so back cannot restore auth SPA state. */
export async function hardLogoutRedirect(path) {
  await clearHologramPageSnapshots();
  location.replace(path);
}

/** BFCache restore of an auth page must hit the server again (middleware). */
export function startBfcacheAuthGuard() {
  if (bfcacheGuard) return;
  bfcacheGuard = true;

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) location.reload();
  });
}
